module.exports = __webpack_public_path__ + "static/media/marker.43535f98.png";